

$("#giftingForm").submit(function(event) {
    event.preventDefault();
    var values = {};
    $.each($('#giftingForm').serializeArray(), function(i, field) {
        values[field.name] = field.value;
    });
    if(values.order_type === "Delivery") {
        var order_type = {
            'delivery_date': values.delivery_date,
            'delivery_type' : values.delivery_type,
            'business_name' : values.business_name,
            'operation_hours' : values.operation_hours,
            'recipient_address' : values.recipient_address,
            'recipient_unit' : values.recipient_unit,
            'recipient_city' : values.recipient_city,
            'recipient_pc' : values.recipient_pc,
            'delivery_instructions' : values.delivery_instructions
        }
    } else if (values.order_type === "Pick Up") {
        var order_type = {
            'pickup_date': values.pickup_date,
            'who_pickup' : values.who_pickup,
            'name_pickup' : values.name_pickup,
            'phone_number_pickup' : values.phone_number_pickup,
        }
    }
    _learnq.push(['identify', {
      // Change the line below to dynamically print the user's email.
      '$email': values.email
    }]);
    setTimeout(function(){
        _learnq.push(['track', 'Gift Basket Order', {
            'first_name' : values.first_name,
            'last_name' : values.last_name,
            'phone_number' : values.phone_number,
            'new_client' : values.new_client,
            'company' : values.company,
            'email': values.email,
            'new_client' : values.new_client,
            'order_type' : values.order_type,
            'order_type_object' : order_type,
            'recipient_city' : values.recipient_city,
            'single_bottle_wrap' : values.single_bottle_wrap,
            'multiple_bottle_wrap' : values.multiple_bottle_wrap,
            'total_budget' : values.total_budget,
            'product_preferences' : values.product_preferences,
            'card' : values.card,
            'to_name' : values.to_name,
            'from_name' : values.from_name,
            'card_message' : values.card_message,
            'name_recipient' : values.name_recipient,
            'email_recipient' : values.email_recipient,
            'phone_number_recipient' : values.phone_number_recipient,
            'accessory_preferences' : values.accessory_preferences
    
          }]);
    }, 1000);
    $(this).addClass("d-none");
    $('.success_message').removeClass("d-none");
});
$("#eventQuoteForm").submit(function(event) {
    event.preventDefault();
    var values = {};
    var beverage_array = [];
    $.each($(this).serializeArray(), function(i, field) {
        if(field.name == 'beverage_needs') {
            beverage_array.push(field.value);
        } else{
        values[field.name] = field.value;
        }
    });
    values['beverage_needs'] = beverage_array;
    _learnq.push(['identify', {
      // Change the line below to dynamically print the user's email.
      '$email': values.email
    }]);
    setTimeout(function(){
        _learnq.push(['track', 'Special Event Quote', {
            'first_name' : values.first_name,
            'last_name' : values.last_name,
            'phone_number' : values.phone_number,
            'company' : values.company,
            'email': values.email,
            'order_type' : values.order_type,
            'attendence' : values.attendence,
            'product_preferences' : values.product_preferences,
            'food_pair' : values.food_pair,
            'beverage_needs' : values.beverage_needs,
            'event_date' : values.event_date, 
            'pickup_date' : values.pickup_date,
            'style' : values.style,
            'hours' : values.hours
          }]);
    }, 1000);
    $(this).addClass("d-none");
    $('.success_message').removeClass("d-none")
});
$("#supportForm").submit(function(event) {
    event.preventDefault();
    var values = {};
    $.each($('#supportForm').serializeArray(), function(i, field) {
        values[field.name] = field.value;
    });
    _learnq.push(['identify', {
      // Change the line below to dynamically print the user's email.
      '$email': values.email
    }]);
    setTimeout(function(){
        _learnq.push(['track', 'Request Support', {
            'first_name' : values.first_name,
            'last_name' : values.last_name,
            'phone_number' : values.phone_number,
            'organization' : values.organization,
            'email': values.email,
            'charitable' : values.charitable,
            'event_name' : values.event_name,
            'details' : values.details,
            'past_support' : values.past_support,
            'value' : values.value,
            'event_date' : values.event_date, 
            'proceeds' : values.proceeds
    
          }]);
    }, 1000);

    $(this).addClass("d-none");
    $('.success_message').removeClass("d-none")
});



function formToggle(display, hide) {
    if(display) {
        $(display + ' input,' + display + ' textarea').each(function() {
            $(this).attr('disabled', false);
        });
        $(display).removeClass("d-none");
    }
    if(hide) {
        $(hide + ' input,' + hide + ' textarea').each(function() {
            $(this).attr('disabled', true);
        });
        $(hide).addClass("d-none");
    }
};
$("#contactUsForm").submit(function(event) {
    event.preventDefault();
    var values = {};
    $.each($(this).serializeArray(), function(i, field) {
        values[field.name] = field.value;
    });
    _learnq.push(['identify', {
      // Change the line below to dynamically print the user's email.
      '$email': values.email,
    }]);
    setTimeout(function(){
        _learnq.push(['track', 'Contact Us', {
            'first_name' : values.first_name,
            'last_name' : values.last_name,
            'phone_number' : values.phone_number,
            'subject' : values.subject,
            'email': values.email,
            'message': values.message
        }]);
    }, 1000);
    $(this).addClass("d-none");
    $('.success_message').removeClass("d-none")
});

